var map = {
  12: {
    '0s': '6,6',
    '0d': ''
  },
  '2,10': {
    '1r': '3,9',
    '0d': '12',
    '1d': '12',
    '0s': '2,2,8',
    '1s': '4,4,4'
  },
  '3,9': {
    '1r': '4,8',
    '1l': '2,10',
    '0d': '12',
    '1d': '12',
    '0s': '2,2,8',
    '1s': '4,4,4'
  },
  '4,8': {
    '1r': '6,6',
    '1l': '3,9',
    '0d': '12',
    '1d': '12',
    '0s': '2,2,8',
    '1s': '4,4,4'
  },
  '6,6': {
    '1r': '8,4',
    '1l': '4,8',
    '0d': '12',
    '1d': '12',
    '0s': '3,3,6',
    '1s': '6,3,3'
  },
  '8,4': {
    '1r': '9,3',
    '1l': '6,6',
    '0d': '12',
    '1d': '12',
    '0s': '4,4,4',
    '1s': '8,2,2'
  },
  '9,3': {
    '1r': '10,2',
    '1l': '8,4',
    '0d': '12',
    '1d': '12',
    '0s': '4,4,4',
    '1s': '8,2,2'
  },
  '10,2': {
    '1l': '9,3',
    '0d': '12',
    '1d': '12',
    '0s': '4,4,4',
    '1s': '8,2,2'
  },
  '4,4,4': {
    '1l': '3,6,3',
    '1r': '6,3,3',
    '2l': '3,3,6',
    '2r': '3,6,3',
    '0d': '6,6',
    '1d': '6,6',
    '2d': '6,6',
    '0s': '3,3,3,3',
    '1s': '3,3,3,3',
    '2s': '3,3,3,3'
  },
  '6,3,3': {
    '1l': '4,4,4',
    '1r': '8,2,2',
    '2l': '4,4,4',
    '2r': '8,2,2',
    '0d': '6,6',
    '1d': '8,4',
    '2d': '8,4',
    '0s': '3,3,3,3',
    '1s': '6,2,2,2',
    '2s': '6,2,2,2'
  },
  '8,2,2': {
    '1l': '6,3,3',
    '2l': '6,3,3',
    '0d': '6,6',
    '1d': '8,4',
    '2d': '8,4',
    '0s': '3,3,3,3',
    '1s': '6,2,2,2',
    '2s': '6,2,2,2'
  },
  '3,6,3': {
    '1l': '2,8,2',
    '1r': '4,4,4',
    '2l': '4,4,4',
    '2r': '2,8,2',
    '0d': '8,4',
    '1d': '6,6',
    '2d': '4,8',
    '0s': '2,2,6,2',
    '1s': '3,3,3,3',
    '2s': '2,6,2,2'
  },
  '2,8,2': {
    '1r': '3,6,3',
    '2l': '3,6,3',
    '0d': '8,4',
    '1d': '6,6',
    '2d': '4,8',
    '0s': '2,2,6,2',
    '1s': '3,3,3,3',
    '2s': '2,6,2,2'
  },
  '3,3,6': {
    '1l': '2,2,8',
    '1r': '4,4,4',
    '2l': '2,2,8',
    '2r': '4,4,4',
    '0d': '4,8',
    '1d': '4,8',
    '2d': '6,6',
    '0s': '2,2,2,6',
    '1s': '2,2,2,6',
    '2s': '3,3,3,3'
  },
  '2,2,8': {
    '1r': '3,3,6',
    '2r': '3,3,6',
    '0d': '4,8',
    '1d': '4,8',
    '2d': '6,6',
    '0s': '2,2,2,6',
    '1s': '2,2,2,6',
    '2s': '3,3,3,3'
  },
  '3,3,3,3': {
    '1l': '2,6,2,2',
    '1r': '6,2,2,2',
    '2l': '2,2,6,2',
    '2r': '2,6,2,2',
    '3l': '2,2,2,6',
    '3r': '2,2,6,2',
    '0d': '4,4,4',
    '1d': '4,4,4',
    '2d': '4,4,4',
    '3d': '4,4,4',
    '0s': '2,2,2,4,2',
    '1s': '2,2,2,2,4',
    '2s': '4,2,2,2,2',
    '3s': '2,4,2,2,2'
  },
  '6,2,2,2': {
    '1l': '3,3,3,3',
    '2l': '3,3,3,3',
    '3l': '3,3,3,3',
    '0d': '4,4,4',
    '1d': '6,3,3',
    '2d': '6,3,3',
    '3d': '6,3,3',
    '0s': '4,2,2,2,2',
    '1s': '4,2,2,2,2',
    '2s': '4,2,2,2,2',
    '3s': '4,2,2,2,2'
  },
  '2,6,2,2': {
    '1r': '3,3,3,3',
    '2l': '3,3,3,3',
    '3l': '3,3,3,3',
    '0d': '6,3,3',
    '1d': '4,4,4',
    '2d': '3,6,3',
    '3d': '3,6,3',
    '0s': '2,2,4,2,2',
    '1s': '2,2,4,2,2',
    '2s': '2,4,2,2,2',
    '3s': '2,4,2,2,2'
  },
  '2,2,6,2': {
    '1r': '3,3,3,3',
    '2r': '3,3,3,3',
    '3l': '3,3,3,3',
    '0d': '3,6,3',
    '1d': '3,6,3',
    '2d': '4,4,4',
    '3d': '3,3,6',
    '0s': '2,2,2,4,2',
    '1s': '2,2,2,4,2',
    '2s': '2,2,4,2,2',
    '3s': '2,2,4,2,2'
  },
  '2,2,2,6': {
    '1r': '3,3,3,3',
    '2r': '3,3,3,3',
    '3r': '3,3,3,3',
    '0d': '3,3,6',
    '1d': '3,3,6',
    '2d': '3,3,6',
    '3d': '4,4,4',
    '0s': '2,2,2,2,4',
    '1s': '2,2,2,2,4',
    '2s': '2,2,2,2,4',
    '3s': '2,2,2,2,4'
  },
  '4,2,2,2,2': {
    '1l': '2,4,2,2,2',
    '2l': '2,2,4,2,2',
    '3l': '2,2,2,4,2',
    '4l': '2,2,2,2,4',
    '0d': '3,3,3,3',
    '1d': '3,3,3,3',
    '2d': '3,3,3,3',
    '3d': '3,3,3,3',
    '4d': '3,3,3,3',
    '0s': '2,2,2,2,2,2',
    '1s': '2,2,2,2,2,2',
    '2s': '2,2,2,2,2,2',
    '3s': '2,2,2,2,2,2',
    '4s': '2,2,2,2,2,2'
  },
  '2,4,2,2,2': {
    '1r': '4,2,2,2,2',
    '2l': '2,2,4,2,2',
    '3l': '2,2,2,4,2',
    '4l': '2,2,2,2,4',
    '0d': '3,3,3,3',
    '1d': '3,3,3,3',
    '2d': '3,3,3,3',
    '3d': '3,3,3,3',
    '4d': '3,3,3,3',
    '0s': '2,2,2,2,2,2',
    '1s': '2,2,2,2,2,2',
    '2s': '2,2,2,2,2,2',
    '3s': '2,2,2,2,2,2',
    '4s': '2,2,2,2,2,2'
  },
  '2,2,4,2,2': {
    '1r': '4,2,2,2,2',
    '2r': '2,4,2,2,2',
    '3l': '2,2,2,4,2',
    '4l': '2,2,2,2,4',
    '0d': '3,3,3,3',
    '1d': '3,3,3,3',
    '2d': '3,3,3,3',
    '3d': '3,3,3,3',
    '4d': '3,3,3,3',
    '0s': '2,2,2,2,2,2',
    '1s': '2,2,2,2,2,2',
    '2s': '2,2,2,2,2,2',
    '3s': '2,2,2,2,2,2',
    '4s': '2,2,2,2,2,2'
  },
  '2,2,2,4,2': {
    '1r': '4,2,2,2,2',
    '2r': '2,4,2,2,2',
    '3r': '2,2,4,2,2',
    '4l': '2,2,2,2,4',
    '0d': '3,3,3,3',
    '1d': '3,3,3,3',
    '2d': '3,3,3,3',
    '3d': '3,3,3,3',
    '4d': '3,3,3,3',
    '0s': '2,2,2,2,2,2',
    '1s': '2,2,2,2,2,2',
    '2s': '2,2,2,2,2,2',
    '3s': '2,2,2,2,2,2',
    '4s': '2,2,2,2,2,2'
  },
  '2,2,2,2,4': {
    '1r': '4,2,2,2,2',
    '2r': '2,4,2,2,2',
    '3r': '2,2,4,2,2',
    '4r': '2,2,2,4,2',
    '0d': '3,3,3,3',
    '1d': '3,3,3,3',
    '2d': '3,3,3,3',
    '3d': '3,3,3,3',
    '4d': '3,3,3,3',
    '0s': '2,2,2,2,2,2',
    '1s': '2,2,2,2,2,2',
    '2s': '2,2,2,2,2,2',
    '3s': '2,2,2,2,2,2',
    '4s': '2,2,2,2,2,2'
  },
  '2,2,2,2,2,2': {
    '0d': '4,2,2,2,2',
    '1d': '4,2,2,2,2',
    '2d': '2,4,2,2,2',
    '3d': '2,2,4,2,2',
    '4d': '2,2,2,4,2',
    '5d': '2,2,2,2,4'
  }
};
export default map;